export default "__VITE_ASSET__BXb3HZ7x__"